<div class="products-market-row-container">
    @for (product of products; track product.id; let i = $index) {
        <app-product-market-row-item [item]="product" [isFeaturedRow]="false" [showRestaurantName]="showRestaurantName"></app-product-market-row-item>
    }
</div>